import React, { FC }       from 'react';
import { Label }           from 'semantic-ui-react';
import { SemanticUIColor } from '../../../types';

export interface TotalActiveLabelProps {
	total?: number,
	activeCount?: number,
	label?: string,
	labelPlural?: string,
	activeLabel?: string,
	activeColor?: SemanticUIColor,
	completedColor?: SemanticUIColor,
	inactiveColor?: SemanticUIColor,
	
	[ additionalProps: string ]: any
}

const defaultProps: TotalActiveLabelProps = {
	total:          0,
	activeCount:    0,
	label:          'Item',
	labelPlural:    'Items',
	activeLabel:    'Displayed',
	activeColor:    SemanticUIColor.GREEN,
	completedColor: SemanticUIColor.GREEN,
	inactiveColor:  null,
}

const TotalActiveLabel: FC<TotalActiveLabelProps> = ( _props ) => {
	
	let {
		    total,
		    activeCount,
		    activeColor,
		    inactiveColor,
		    completedColor,
		    labelPlural,
		    label,
		    activeLabel,
		    ...props
	    } = _props;
	
	return (
		<Label color={ ( total > 0 ) ? ( total === activeCount ) ? completedColor : activeColor : inactiveColor } { ...props }>
			
			{ total === activeCount
			  ? <>{ total } { total > 1 ? labelPlural : label }</>
			  : <>{ activeCount } / { total } { activeLabel }</>
			}
		</Label>
	);
};

TotalActiveLabel.defaultProps = defaultProps;

export { TotalActiveLabel }
